import { Link } from "react-router-dom";
import { categories } from "@/mocks/comics";

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-secondary-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-accent-500 text-sm font-bold text-background-50">
                蛙
              </span>
              <span className="font-heading text-lg font-extrabold text-background-50">
                漫蛙漫画网
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-secondary-200/90">
              专注连载更新与追更提醒的中文漫画平台。收录最新章节、作品列表、作者专区与系列漫画，订阅后第一时间获知更新动态，追更体验顺畅高效。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50">快速导航</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link className="text-secondary-200/90 hover:text-accent-400" to="/works">作品列表</Link></li>
              <li><Link className="text-secondary-200/90 hover:text-accent-400" to="/authors">作者专区</Link></li>
              <li><Link className="text-secondary-200/90 hover:text-accent-400" to="/about">关于我们</Link></li>
              <li><a className="text-secondary-200/90 hover:text-accent-400" href="#subscribe">追更提醒</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50">作品分类</h3>
            <ul className="mt-4 flex flex-wrap gap-x-3 gap-y-2.5 text-sm">
              {categories.slice(1).map((c) => (
                <li key={c.key}>
                  <Link className="text-secondary-200/90 hover:text-accent-400" to={`/works?cat=${encodeURIComponent(c.key)}`}>
                    {c.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50">联系我们</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-secondary-200/90">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400" aria-hidden="true" />
                contact@manwa.example.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-accent-400" aria-hidden="true" />
                更新时段 12:00 与 20:00
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-global-line text-accent-400" aria-hidden="true" />
                简体中文
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-secondary-800 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-secondary-300">
            © {new Date().getFullYear()} 漫蛙漫画网 · 为追更而生的漫画阅读平台
          </p>
          <p className="text-xs text-secondary-300">本站内容仅供交流分享 · 尊重原创版权</p>
        </div>
      </div>
    </footer>
  );
}